import Collapsible from "react-collapsible";
import { FaPlaneDeparture } from "react-icons/fa";
import FlightsTable from "./FlightsTable";
import NoFlightsMessage from "./NoFlightsMessage";
import Collabse from "../../../components/Collabse";
import { useTranslation } from "react-i18next";

const Flights = () => {
  return (
    <Collabse Header={Header}>
      <FlightsTable />
      <NoFlightsMessage />
    </Collabse>
  );
};

const Header = () => {
  const { t } = useTranslation();

  return (
    <h5>
      <FaPlaneDeparture />
      {t("bookingDetails.flights.title")}
    </h5>
  );
};

export default Flights;
